import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { useEffect } from 'react';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const ThankYouPoletje2025 = ({hibisId, scAnswer}) => {

  useEffect(() => {
    const idMap = {
      a: 'id_nl_7_interes_1',
      b: 'id_nl_7_interes_2',
      c: 'id_nl_7_interes_3',
      d: 'id_nl_7_interes_4',
      e: 'id_nl_7_interes_5',
      f: 'id_nl_7_interes_6'
    };

    const normalized = scAnswer?.toLowerCase();
    if (!normalized || !idMap[normalized]) return;

    let retries = 0;
    const maxRetries = 10;

    const tryCheck = () => {
      const el = document.getElementById(idMap[normalized]);
      if (el) {
        el.checked = true;
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(tryCheck, 300);
      } else {
        console.warn('Checkbox not found after max retries');
      }
    };

    tryCheck();
  }, [scAnswer]);

  return (
    <>
      <Header />
      <Hero image="oskar-interesi.jpg" xPos="28%" yPos="44%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Kako bi danes porabili 15.000 €?</h1>
                    <p className="text-left">
                      Z ugodnim Addiko gotovinskim kreditom lahko svoje načrte uresničite lažje kot kadarkoli prej – ne glede na to, ali želite poplačati obstoječe obveznosti, prenoviti stanovanje, zamenjati avto ali preprosto zadihati bolj sproščeno.
                    </p>
                    <p className="text-left">
                      <b>Obrestna mera zdaj znaša samo 4,5 %</b>, kar pomeni manj stroškov in več svobode za vaše odločitve. Izpolnite obrazec, označite, kaj vam trenutno največ pomeni, in poslali vam bomo informacije, prilagojene vašim željam.
                    </p>
                    <p className="text-left">
                      <b>Zato, ker je pravi čas, da zase naredite nekaj dobrega.</b>
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="0e92121d-b218-4d22-b2f3-1dd105c1119b" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}